import React, { useEffect } from "react";

import top from "../../images/planes/top-nuestros-planes.png";
import phoneoldie from "../../images/header-quehacemos.jpg";
import mobile from "../../images/planes/mobile-planes.png";

// import web from "../../images/plataforma/desktop-home-1.png";
// import smartwatch from "../../images/plataforma/sw-home.png";

import "./QueHacemos.css";
import Testimonios from "../molecules/Testimonios";
import ConoceEllieCoins from "../molecules/ConoceEllieCoins";
import Servicios from "../molecules/Servicios";
import Contacto from "../molecules/Contacto";

export const QueHacemos = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <img
        src={phoneoldie}
        alt="Funny Oldies"
        style={{ width: "100%", margin: "0 auto" }}
      />

      <div id="nuestros-planes">
        <div className="nuestros-planes-container">
          <img
            className="nuestros-planes-image-top"
            src={top}
            alt="Top Porpósito"
          />
        </div>

        <div className="nuestros-planes-container">
          <div className="nuestros-planes-box">
            <h1>
              Ellie Care es la plataforma de bienestar más innovadora y completa
              para el segmento +65 años.
            </h1>
            <p>
              Ya sea para uno mismo, para tus padres o abuelos, para los
              empleados, afiliados o clientes en una empresa, para los miembros
              de una comunidad (barrio, ciudad, etc.).
            </p>
            <p>¡Cualquiera puede tener ellie Care!</p>
          </div>
          <div
            className="nuestros-planes-box-image"
            style={{ display: "flex" }}
          >
            <img
              className="nuestros-planes-image"
              src={mobile}
              alt="Mobile Planes"
              style={{ marginBottom: "50px" }}
            />
          </div>
        </div>
        <Servicios />
        <Testimonios />
        <ConoceEllieCoins />
        <section id="contact">
          <Contacto />
        </section>
      </div>
    </>
  );
};

export default QueHacemos;
